"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TypedRecord = _interopRequireDefault(require("./TypedRecord"));

var _isInstanceOf = _interopRequireDefault(require("transmute/isInstanceOf"));

var _get = _interopRequireDefault(require("transmute/get"));

var _map = _interopRequireDefault(require("transmute/map"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var _toJS = _interopRequireDefault(require("transmute/toJS"));

var _every = _interopRequireDefault(require("transmute/every"));

var _both = _interopRequireDefault(require("transmute/both"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var ReferenceRecord = (0, _TypedRecord.default)({
  id: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.number.isRequired]).isRequired,
  label: {
    type: _propTypes.default.string.isRequired,
    default: ''
  },
  description: _propTypes.default.string,
  icon: _reactImmutableProptypes.default.contains({
    type: _propTypes.default.oneOf(['image']).isRequired,
    src: _propTypes.default.string.isRequired
  }),
  disabled: _propTypes.default.bool,
  referencedObject: _propTypes.default.any
}, 'ReferenceRecord');
/**
 * Returns `true` if `reference` is a ReferenceRecord.
 *
 * @param {any} reference
 * @return {boolean}
 */

ReferenceRecord.isReferenceRecord = (0, _isInstanceOf.default)(ReferenceRecord);
/**
 * Returns `true` if `iterable` is a Immutable.Iterable of ReferenceRecords
 *
 * @param  {any} iterable
 * @return {boolean}
 */

ReferenceRecord.isReferenceIterable = (0, _both.default)((0, _isInstanceOf.default)(_immutable.Iterable), (0, _every.default)(ReferenceRecord.isReferenceRecord));
/**
 * Throws if `reference` is not a ReferenceRecord.
 *
 * @param  {any} reference
 * @param  {?string} key       optional context key for the error
 * @return {ReferenceRecord}
 */

ReferenceRecord.enforceReferenceRecord = function (reference, key) {
  (0, _invariant.default)(ReferenceRecord.isReferenceRecord(reference), 'expected `%s` to be a ReferenceRecord but got `%s`', key === undefined ? 'reference' : "references[" + key + "]", reference);
  return reference;
};
/**
 * Throws if `references` contains anything that isn't a ReferenceRecord.
 *
 * @param  {any} references
 * @return {Iterable<ReferenceRecord>}
 */


ReferenceRecord.enforceReferenceIterable = function (references) {
  (0, _invariant.default)(ReferenceRecord.isReferenceIterable(references), 'expected `references` to be an Immutable.Iterable of ReferenceRecords but got `%s`', references);
  return references;
};
/**
 * Converts a ReferenceRecord to a UISelect compatible option.
 *
 * @param  {ReferenceRecord} reference
 * @return {{label: string, help?: string, value: string}}
 */


ReferenceRecord.toOption = function (reference) {
  if (!reference) {
    return reference;
  }

  var id = reference.id,
      label = reference.label,
      description = reference.description,
      icon = reference.icon,
      disabled = reference.disabled;
  var option = {
    text: label || id,
    value: id
  };

  if (description) {
    option.help = description;
  }

  if (icon) {
    option.imageUrl = (0, _get.default)('src', icon);
  }

  if (disabled) {
    option.disabled = !!disabled;
  }

  return option;
};
/**
 * Converts an Iterable, or Array of ReferenceRecords to an Array of UISelect
 * compatible options.
 *
 * @param {Array<ReferenceRecord>|Iterable<ReferenceRecord>} references
 * @return {Array<Object>}
 */


ReferenceRecord.toOptionsArray = (0, _pipe.default)((0, _map.default)(ReferenceRecord.toOption), _toJS.default);
var _default = ReferenceRecord;
exports.default = _default;
module.exports = exports.default;